import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";

export default function SchedulerStatusTabs({options, selectedStatus, statusCounts, onChange}) {
    return (
        <ButtonGroup>
            {options.map((option) => {
                const countKey = option.countKey || option.value || option.label;
                const count = statusCounts[countKey] || 0;

                return (
                    <ToggleButton
                        key={option.value}
                        id={`scheduler-status-${option.value}`}
                        type="radio"
                        variant={option.variant}
                        name="scheduler-status"
                        value={option.value}
                        checked={selectedStatus === option.value}
                        onChange={(event) => onChange(event.currentTarget.value)}
                    >
                        {option.label}{count ? (
                            <>{" "}<span className="scheduler-status-count">({count})</span></>
                        ) : null}
                    </ToggleButton>
                );
            })}
        </ButtonGroup>
    );
}
